var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconShare = function SvgIconShare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "nonzero",
    d: "M14.723 11.034a3.143 3.143 0 0 0-2.471 1.212L6.879 9.5C6.95 9.237 7 8.966 7 8.68c0-.31-.06-.603-.144-.887l5.35-2.735a3.143 3.143 0 0 0 2.518 1.268 3.162 3.162 0 1 0 0-6.326 3.163 3.163 0 0 0-3.163 3.162c0 .286.05.558.122.821L6.311 6.731a3.15 3.15 0 0 0-2.475-1.215A3.162 3.162 0 0 0 .674 8.68a3.162 3.162 0 0 0 3.162 3.163 3.15 3.15 0 0 0 2.522-1.27l5.346 2.735a3.125 3.125 0 0 0-.144.89 3.163 3.163 0 1 0 3.163-3.164z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-share.ae8dbe81.svg";
export { ForwardRef as ReactComponent };